import { render, staticRenderFns } from "./UserProfileSideBar.vue?vue&type=template&id=76d0fd4a&scoped=true&"
import script from "./UserProfileSideBar.vue?vue&type=script&lang=js&"
export * from "./UserProfileSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d0fd4a",
  null
  
)

export default component.exports